import { createApp } from 'vue'
import { createPinia } from 'pinia'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'
import { initializeApi } from './api'
import { useAuthStore } from './stores/auth'
import { vuesticThemeConfig, cssVariables } from './config/theme'
import { useTheme } from './composables/useTheme'
import config from './config/env'

// import stores from './stores'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import App from './App.vue'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
// app.use(stores)
app.use(router)
app.use(i18n)

// Apply CSS variables to root element
const root = document.documentElement
Object.entries(cssVariables).forEach(([property, value]) => {
  root.style.setProperty(property, value)
})

// Merge theme config with existing vuestic config
const mergedConfig = {
  ...vuesticGlobalConfig,
  colors: {
    ...vuesticGlobalConfig.colors,
    ...vuesticThemeConfig.colors,
  },
}

app.use(createVuestic({ config: mergedConfig }))

// Initialize theme watcher after Vuestic is set up
setTimeout(() => {
  const { updateCSSVariables } = useTheme()
  updateCSSVariables()
}, 0)

if (config.gtm.enabled) {
  app.use(
    createGtm({
      id: config.gtm.key,
      debug: config.isDevelopment,
      vueRouter: router,
    }),
  )
}

initializeApi(router, () => useAuthStore(pinia))

app.mount('#app')
